import type {
  ComprehensiveAccountTransactionCondition,
  ComprehensiveAccountTransactionListItem,
  ComprehensiveAccountTransactionListParams,
} from './types/transaction'

import type { PagingRequest } from '#/api/type'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'
import { TransactionType } from '#/types'
import { formatDateRange } from '#/utils'

export const comprehensiveAccountTransactionApi = defineApi(
  'operation',
  ({ prefix }) => {
    function buildCondition(
      condition: ComprehensiveAccountTransactionListParams['condition'],
    ) {
      return {
        createdTime: formatDateRange(condition.createdTime),
        bizNo: condition.bizNo,
        accountId: condition.accountId,
        accountName: condition.accountName,
        customerIds: condition.customerIds,
        nickname: condition.nickname,
        agent: condition.agent,
        type: condition.type,
        mediaPlatform: condition.mediaPlatform,
        accountType: condition.accountType,
        status: ['COMPLETED'],
      }
    }

    function getComprehensiveAccountTransactionList(
      params: PagingRequest<ComprehensiveAccountTransactionListParams>,
    ) {
      const requestParams = {
        pageIndex: params.pageIndex,
        pageSize: params.pageSize,
        condition: buildCondition(params.condition),
      }

      return requestClient
        .post(prefix('wallet/listAdRecharge'), requestParams)
        .then((res) => {
          return {
            items:
              res.list?.map(
                (item: ComprehensiveAccountTransactionListItem) => ({
                  createdTime: item.createdTime,
                  bizNo: item.bizNo,
                  userId: item.userId,
                  nickname: item.nickname,
                  createdBy: item.createdBy,
                  email: item.email,
                  agent: item.agent,
                  accountId: item.accountId,
                  accountName: item.accountName,
                  currency: item.currency,
                  mediaPlatform: item.mediaPlatform,
                  status: item.status,
                  amount: item.amount,
                  customerId: item.customerId,
                  rate: item.rate,
                  agencyServiceRate: item.agencyServiceRate,
                  prepaidRate: item.prepaidRate,
                  prepaidFee: item.prepaidFee,
                  totalServiceFee: item.totalServiceFee,
                  ourCompanyServiceFee: item.ourCompanyServiceFee,
                  agencyServiceFee: item.agencyServiceFee,
                  actualAmount: item.actualAmount,
                  balanceBefore: item.balanceBefore,
                  customerCurrency: item.customerCurrency,
                  customerAmount:
                    item.type === TransactionType.RECHARGE
                      ? -item.customerAmount
                      : item.customerAmount,
                  type: item.type,
                  accountType: item.accountType,
                  completedAt: item.completedAt,
                  clearDate: item.clearDate,
                  remark: item.remark,
                }),
              ) || [],
            total: res.total,
          }
        })
    }

    function exportComprehensiveAccountTransactionList(
      params: ComprehensiveAccountTransactionCondition,
    ) {
      return requestClient
        .post(prefix('wallet/exportAdTransaction'), {
          condition: buildCondition(params),
        })
        .then((res) => {
          return {
            fileUrl: res?.downloadUrl,
            fileName: res?.fileName,
          }
        })
    }

    return {
      getComprehensiveAccountTransactionList,
      exportComprehensiveAccountTransactionList,
    }
  },
)
